import React, { Component } from 'react'

import './style.scss'

class About extends Component {
  render () {
    return (
      <div className="about">
        <div className="image">
        </div>
        <div className="bio">
          Hi there! 👋<br/><br/>Thanks for checking out my portfolio. This is a
          very brief overview of the work I've done. If you'd like to
          hear more please drop me a line in the chat below!
        </div>
      </div>
    )
  }
}

export default About


// WEBPACK FOOTER //
// ./src/components/Sidebar/About/index.js